/* unplugin-vue-components disabled */
import {Rest} from 'utils'
import PromptBlock from './prompt-block.vue'
import AddMessage from './add-message.vue'
import {API_PLAYGROUND} from 'consts/api'
import {MODELS, ROLES} from './playground-defs'
import {markRaw} from 'vue'


const DEF_TEMP = 0.7
const DEF_MODEL = 'gpt-4.1'

export default {
  components: {
    PromptBlock, AddMessage
  },
  props: {
    promptName: {type: String, default: undefined}
  },
  data() {
    return {
      rest: new Rest(),
      name: undefined,
      prompt_old: undefined,
      prompt_struct: [],
      model: DEF_MODEL,
      temperature: DEF_TEMP,
      loading: false,
      MODELS: markRaw(MODELS),
      saving: false,
    }
  },
  computed: {
    prompt_data() {
      return {
        name: this.name,
        type: 'chat',
        prompt: this.prompt_struct,
        config: {
          model: this.model,
          temperature: this.temperature,
        },
      }
    },
    same(){
      if (!this.name) return true
      return $utils.object.same(this.prompt_data, this.prompt_old)
    },

    valid() {
      return !this.prompt_struct.some(x => x.type === 'placeholder' && !x.name)
    },
    can_save() {
      return this.valid && !this.same && !this.saving
    }
  },
  watch: {
    async promptName() {
      this.loading = true
      this.prompt_struct = []
      const prompt = await this.rest.get(`${API_PLAYGROUND}/prompts/${this.promptName}`)
      if (prompt.type === 'chat') {
        this.prompt_struct = prompt.prompt
        this.name = prompt.name
      }
      else if (prompt.type === 'text') {
        this.prompt_struct = [{role: 'user', content: prompt.prompt}]
        this.name = prompt.name + '_chat'
      }

      this.model = prompt.config?.model || DEF_MODEL
      this.temperature = typeof prompt.config?.temperature === 'number' ? prompt.config?.temperature : DEF_TEMP

      this.prompt_old = $utils.object.deepCopy(this.prompt_data)
      this.loading = false
    }
  },
  methods: {
    addMessage(action) {
      this.prompt_struct.push({
        role: action.role,
        content: ''
      })
    },
    addPlaceholder() {
      this.prompt_struct.push({
        type: 'placeholder',
        name: ''
      })
    },
    deleteBlock(idx) {
      this.prompt_struct = this.prompt_struct.filter((_, i) => i !== idx)
    },
    async save() {
      this.saving = true
      const payload = {
        name: this.name,
        type: 'chat',
        prompt: this.prompt_struct,
        config: {
          model: this.model,
          temperature: this.temperature,
        }
      }
      await this.rest.post(`${API_PLAYGROUND}/prompts`, payload)
      this.prompt_old = $utils.object.deepCopy(this.prompt_data)
      this.saving = false
      $utils.toasts.success('Prompt has been saved.', 5000)
    },
    toggleAdd() {
      if (this.prompt_struct.at(-1)?.role === 'user') {
        this.prompt_struct.push({role: 'assistant', content: ''})
      }
      else {
        this.prompt_struct.push({role: 'user', content: ''})
      }
    },
    changeRole(i, role) {
      const cur = ROLES.findIndex(r => r.role === role)
      const next = (cur + 1) % ROLES.length
      this.prompt_struct[i].role = ROLES[next].role
    }
  }
} 
